import InfoCell from "@/modules/common/components/ui-kit/info-cell";
import { PaymentTerms, PropertyPrice } from "@/modules/property-tracks/types";
import { Box } from "@mui/material";

export default function PropertyPriceData({
  propertyPrice,
  extraFields = false,
}: {
  propertyPrice: PropertyPrice;
  extraFields?: boolean;
}) {
  const renderPriceDetails = () => {
    switch (propertyPrice?.paymentType) {
      case "cash":
        return (
          <InfoCell
            title={`Total Asking Price`}
            description={
              propertyPrice.price
                ? `${propertyPrice.price.toLocaleString()}`
                : "N/A"
            }
          />
        );
      case "installments":
        return (
          <>
            <InfoCell
              title={`Total Asking Price`}
              description={
                propertyPrice.price
                  ? propertyPrice.price.toLocaleString()
                  : "N/A"
              }
            />
            <InfoCell
              title={`Downpayment (over + paid)`}
              description={
                propertyPrice.downPayment
                  ? propertyPrice.downPayment.toLocaleString()
                  : "N/A"
              }
            />{" "}
            <InfoCell
              title={`Remaining`}
              description={
                propertyPrice.remainingInstallments
                  ? propertyPrice.remainingInstallments.toLocaleString()
                  : "N/A"
              }
            />{" "}
            <InfoCell
              title={`Maintenance`}
              description={
                propertyPrice.maintenance
                  ? propertyPrice.maintenance.toLocaleString()
                  : "N/A"
              }
            />{" "}
            <InfoCell
              title={`Clubhouse`}
              description={
                propertyPrice.clubhouse
                  ? propertyPrice.clubhouse.toLocaleString()
                  : "N/A"
              }
            />
            <InfoCell
              title={`Parking`}
              description={
                propertyPrice.parking
                  ? propertyPrice.parking.toLocaleString()
                  : "N/A"
              }
            />
            {extraFields && (
              <>
                <InfoCell
                  title={`Remaining duration`}
                  description={
                    propertyPrice.durationRemainingYears ||
                    propertyPrice.durationRemainingMonths
                      ? `
                    ${
                      propertyPrice.durationRemainingYears
                        ? propertyPrice.durationRemainingYears + " years "
                        : ""
                    } 
                    ${
                      propertyPrice.durationRemainingMonths
                        ? propertyPrice.durationRemainingMonths + " months "
                        : ""
                    }`
                      : "N/A"
                  }
                />

                <InfoCell
                  title={`Installment frequency`}
                  description={
                    propertyPrice.installmentFrequency
                      ? PaymentTerms[propertyPrice.installmentFrequency]
                      : "N/A"
                  }
                />
              </>
            )}
          </>
        );
      default:
        return <></>;
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "40px",
        justifyContent: "start",
      }}
    >
      {renderPriceDetails()}
    </Box>
  );
}
